import { render } from "./Module.vue?vue&type=template&id=089b3312"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__